import PropTypes from 'prop-types'
import React from 'react'
import {connect} from 'react-redux'

import * as track from '../../../track/track'

import {scrollTo} from '../../../scroll'

import ProductStarRating from './ProductStarRating'

import * as reviews from '../../../store/reviews'

import * as pdp from '../../../store/productDetailPage'

const ReviewStarsNumbers = ({averageScore, isFeaturedReviewsLoaded, productName, totalReviews}) => {
  if (isFeaturedReviewsLoaded) {
    const handleClick = () => {
      const featuredReviewsEl = document.getElementById('featuredProductReviews')
      scrollTo(featuredReviewsEl, {offset: -100, durationTime: 50})
      track.pdpClicked(`${productName} Star Rating`, `${window.location.pathname}/reviews`)
    }
    return (
      <button className="reviews-stars-count" onClick={handleClick}>
        <ProductStarRating score={averageScore} />
        <p className="pdp-reviews-number">({totalReviews})</p>
      </button>
    )
  }
  return null
}

ReviewStarsNumbers.propTypes = {
  averageScore: PropTypes.number.isRequired,
  isFeaturedReviewsLoaded: PropTypes.bool.isRequired,
  productName: PropTypes.string.isRequired,
  totalReviews: PropTypes.number.isRequired,
}

const mapStateToProps = (state) => ({
  averageScore: reviews.averageScore(state),
  isFeaturedReviewsLoaded: reviews.featuredReviewsIsLoaded(state),
  productName: pdp.productName(state),
  totalReviews: reviews.totalReviews(state),
})

export default connect(mapStateToProps)(ReviewStarsNumbers)
